import { render, staticRenderFns } from "./BankAccountReportsTable.vue?vue&type=template&id=4ec14e9e"
import script from "./BankAccountReportsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BankAccountReportsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports